module.exports = __webpack_public_path__ + "img/CircleNotificationsOutlined.53d8a844.svg";